// Third party
import { createSlice } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// Components
import { IRootState } from './type';
import { reducers } from './reducers';
import { TAccountRoot } from '../../types';
import { PERSIST_KEYS, STORE_SLICES } from '../../utils';

const initialState: IRootState = {
  account_roots: [] as TAccountRoot[],
};

export const slice = createSlice({
  name: STORE_SLICES.ACCOUNT_ROOTS_DATA,
  initialState,
  reducers,
});

const accountRootsDataActions = slice.actions;

const accountRootsDataPersistConfig = {
  key: PERSIST_KEYS.ACCOUNT_ROOTS_DATA,
  storage,
  whitelist: ['account_roots'],
};

export { accountRootsDataActions, initialState };
export default persistReducer(accountRootsDataPersistConfig, slice.reducer);
